<template>
  <autocomplete :placeholder="placeholder" :parse="parse" :search="search" v-model="model" :min-characters="0" :is-loading="loading" caret />
</template>

<script>
import Autocomplete from "@/components/layout/components/Autocomplete"
import {listFomaPagamento as list} from "@/domain/financeiro/services/formasPagamento"
const search = function (terms, tipo) {
  let filtros = encodeURI(`&sortBy=name&descending=false&search=${terms}`)
  return list(50, 1, filtros)
}
export default {
  name: "FormaPagamentoInput",
  components: {Autocomplete},
  props: {
    value: {
      required: true
    },
    placeholder: {
      required: false
    }
  },
  data () {
    return {
      model: this.value,
      loading: false
    }
  },
  watch: {
    model(v) {
      this.$emit('input', this.model)
    }
  },
  methods: {
    parse (v) {
      return v && v.nome
    },
    search(terms, done) {
      this.loading = true
      search(terms)
          .then(response => {
            this.loading = false
           let  extra = null
            if (terms) {
              extra = {
                label: `Adicionar "${terms}" como nova forma de pagamento`,
                value: terms,
                isNew: true
              }
            }
            let result = response.data.result.map(p => {
              return {
                ...p,
                label: p.nome,
                value: p.nome,
                active: null
              }
            })
            extra && result.push(extra)
            done(result)
          }).catch(error => {
        this.loading = false
        this.alertApiError(error)
      })
    },
  }
}
</script>
